import { supabase } from "@/shared/lib/supabase";
import { sentryUtils } from "@/shared/utils/sentry";

export async function deleteDocument(estateId: number, documentId: number): Promise<void> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) return;
  const res = await fetch(
    `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/documents/${estateId}/document/${documentId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      },
    },
  );
  if (!res.ok) {
    sentryUtils.captureError(new Error(`Delete document failed: ${res.status}`), "deleteDocument", {
      estateId,
      documentId,
    });
  }
}
